import audio from '../../../../assets/audio/kids-tracks/Text12.mp3';

export const step13talk = {
    id: 13,
    title: 'Úkol',
    taskText: `
        <p>
            Mám takový divný pocit, jako by nás pořád někdo sledoval. To bude asi ta pyšná hraběnka. 
            Raději se k ní otočím čelem a zbytek cesty budu couvat. Chci na ni vidět, kdyby plánovala nějakou neplechu. 
            Přidáš se ke mně? 
        </p>
    `,
    cipher: {
        text: 'Jdi pozadu až k další dopravní značce zákaz zastavení. Pokračuj dále po cestě až dojdeš na autobusovou zastávku.',
        label: 'Úkol',
    },
    continueButtonText: 'Jsme u zastávky',
    points: false,
    audio: audio,
};
